import http from './_http'
import { isWxH5 } from "@utils/business";
import config from "@/config";

/**
 * 抢单下单页分类信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointCategory = (params = {}) => {
    return http({
        url: '/appoint/category',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 抢单下单页 价格计算
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointPriceCal = (params = {}) => {
    return http({
        url: '/appoint/price_cal',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        },
    });
}

/**
 * 下单页创建订单
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointCreateOrder = (params = {}) => {
    return http({
        url: '/appoint/create_order',
        method: 'post',
        params: { appId: isWxH5() ? 'wxe6eec2e6ae38c3cd' : config.appid, payType: 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 普通下单根据订单 id 获取支付信息
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointOrderPay = (params = {}) => {
    return http({
        url: '/appoint/order_pay',
        method: 'post',
        params: { appId: config.appid, payType: isWxH5() ? 3 : 1, ...params },
        meta: {
            login: true,
            toast: true,
            loading: true,
            loadingText: '支付中'
        },
    });
}

/**
 * 抢单 助理订单列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointWaiterOrderPage = (params = {}) => {
    return http({
        url: '/appoint/waiter_order_page',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 普通用户订单列表
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointUserOrderPage = (params = {}) => {
    return http({
        url: '/appoint/user_order_page',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 订单详情
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointOrderDetail = (params = {}) => {
    return http({
        url: '/appoint/order_detail',
        method: 'get',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 助理报名
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointApply = (params = {}) => {
    return http({
        url: '/appoint/apply',
        method: 'post',
        params,
        meta: {
            login: true,
            // toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 助理取消报名
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointCancelApply = (params = {}) => {
    return http({
        url: '/appoint/cancel_apply',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}


/**
 * 抢单 选择助力
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointSelect = (params = {}) => {
    return http({
        url: '/appoint/select',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 修改地址
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointAddressUpdate = (params = {}) => {
    return http({
        url: '/appoint/address_update',
        method: 'post',
        params,
        meta: {
            login: true,
            toast: true,
            loading: true,
        }
    });
}

/**
 * 抢单 订购须知
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const appointServiceInstructions = (params = {}) => {
    return http({
        url: '/appoint/service_instructions',
        method: 'get',
        params,
    });
}
